import Chart from "react-apexcharts";

// Box plot usando rangeBar + puntos
export default function BoxPlotChart({ data, height = 320, color = "#7C3AED" }) {
  // data: [{etapa, p25, promedio, p75, p95}]
  const series = [
    {
      name: "Rango",
      type: "boxPlot",
      data: data.map((d) => ({
        x: d.etapa,
        y: [d.p25, d.p25, d.promedio, d.p75, d.p95],
      })),
    },
  ];

  const options = {
    chart: { type: "boxPlot", toolbar: { show: false }, fontFamily: "Inter, sans-serif" },
    colors: [color],
    plotOptions: {
      boxPlot: {
        colors: { upper: color, lower: color + "80" },
      },
    },
    stroke: { colors: [color] },
    xaxis: {
      labels: { style: { fontSize: "11px", colors: "#64748B" } },
      axisBorder: { show: false },
    },
    yaxis: {
      title: { text: "Minutos", style: { color: "#64748B", fontWeight: 500 } },
      labels: { style: { fontSize: "11px", colors: "#64748B" } },
    },
    grid: { borderColor: "#E2E8F0", strokeDashArray: 3 },
    tooltip: {
      custom: ({ dataPointIndex }) => {
        const d = data[dataPointIndex];
        return `<div style="padding:8px 12px;font-family:Inter">
          <b>${d.etapa}</b><br/>
          P25: ${d.p25} min · Promedio: ${d.promedio} min<br/>
          P75: ${d.p75} min · P95: ${d.p95} min
        </div>`;
      },
    },
  };
  return <Chart options={options} series={series} type="boxPlot" height={height} />;
}
